import { print } from '@/utils'
export const printANSI = () => {
  print(
    {
      title: 'Git Hash',
      content: __GIT_HASH__
    },
    {
      title: 'Build Time',
      content: __BUILD_TIME__
    }
  )
}
